import { environnement } from "configs/environnement";
import api from "./api";
import {
  ITitheResponseDTO,
  ISaveTitheDTO,
  IUpdateTitheDTO,
} from "models/church.types";

const BASE_URL = `${environnement.baseURL}/tithes`;

export const TitheService = {
  getAll: async (page: number, size: number) => {
    const response = await api.get<ITitheResponseDTO[]>(`${BASE_URL}/_search`, {
      params: {
        page: page,
        size: size,
        sort: "id,desc",
        query: "", // Paramètre de recherche vide pour tout lister
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * POST /api/eglise/v1/tithes
   * Enregistrement d'une nouvelle dîme
   */
  create: async (tithe: ISaveTitheDTO): Promise<ITitheResponseDTO> => {
    const response = await api.post<ITitheResponseDTO>(`${BASE_URL}`, tithe);
    return response.data;
  },

  /**
   * PUT /api/eglise/v1/tithes
   * Mise à jour d'une dîme existante
   */
  update: async (tithe: IUpdateTitheDTO): Promise<ITitheResponseDTO> => {
    const response = await api.put<ITitheResponseDTO>(`${BASE_URL}`, tithe);
    return response.data;
  },

  /**
   * GET /api/eglise/v1/tithes/{id}
   * Récupération d'une dîme spécifique par son identifiant
   */
  getById: async (id: number): Promise<ITitheResponseDTO> => {
    const response = await api.get<ITitheResponseDTO>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * DELETE /api/eglise/v1/tithes/{id}
   * Suppression d'une dîme
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * GET /api/eglise/v1/tithes/_search
   * Recherche multicritère avec pagination
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<ITitheResponseDTO[]>(`${BASE_URL}/_search`, {
      params: {
        query: query,
        page: page,
        size: size,
        sort: "id,desc",
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  getSummary: async (
    startDate?: string,
    endDate?: string,
  ) => {
    const response = await api.get<number>(`${BASE_URL}/summary`, {
      params: {
        startDate,
        endDate,
      },
    });
    return response.data; // Retourne le montant (BigDecimal)
  },
};
